import React, { useEffect } from 'react';

function Redirect() {
  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const urlLink = params.get('url');
    
    if (urlLink) {
      try {
        const decodedUrl = atob(urlLink);
        window.location.href = decodedUrl;
      } catch (error) {
        console.error('Error decoding URL:', error);
      }
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#fff'
    }}>
      Redirecting securely.....
    </div>
  );
}

export default Redirect;

